import { EcomodClass } from "../api/models/ecomodClass.models";
import { SupClass } from "../api/models/supClass.models";
import { Locale } from "../types/ui-types";

export const getReusableClass = (value: "none" | "first_use" | "reuse") => {
  switch (value) {
    case "none":
      return 0;
    case "first_use":
      return 1;
    case "reuse":
      return 2;
    default:
      return 0;
  }
};

export const getSupClass = (value: string) => {
  switch (value) {
    case "none":
      return 0;
    case "sup1":
      return 1;
    case "sup2":
      return 2;
    case "sup3":
      return 3;
    default:
      return 0;
  }
};

export const getSupClassFromNumber = (value: number) => {
  switch (value) {
    case 0:
      return "none";
    case 1:
      return "sup1";
    case 2:
      return "sup2";
    case 3:
      return "sup3";
    default:
      return "none";
  }
};

export const getReusableClassFromNumber = (value: number) => {
  switch (value) {
    case 0:
      return "none";
    case 1:
      return "first_use";
    case 2:
      return "reuse";
    default:
      return "none";
  }
};

export const getClassLabelFromAkeneoObject = (
  locale: Locale,
  akeneoClass: Partial<{
    nameFi: string;
    nameSv: string;
    nameEn: string;
  }>,
): string | undefined => {
  switch (locale) {
    case Locale.FI:
      return akeneoClass.nameFi;
    case Locale.SWE:
      return akeneoClass.nameSv || akeneoClass.nameFi;
    case Locale.EN:
      return akeneoClass.nameEn || akeneoClass.nameFi;
    default:
      return akeneoClass.nameFi;
  }
};

export const getSecondaryClassLabelFromAkeneoObject = (
  locale: Locale,
  akeneoClass: Partial<{
    secondaryNameFi: string;
    secondaryNameSv: string;
    secondaryNameEn: string;
  }>,
): string | undefined => {
  switch (locale) {
    case Locale.FI:
      return akeneoClass.secondaryNameFi;
    case Locale.SWE:
      return akeneoClass.secondaryNameSv || akeneoClass.secondaryNameFi;
    case Locale.EN:
      return akeneoClass.secondaryNameEn || akeneoClass.secondaryNameFi;
    default:
      return akeneoClass.secondaryNameFi;
  }
};

export const combineKeys = (
  obj1?: { [key: string]: number },
  obj2?: { [key: string]: number },
): string[] => {
  const keys1 = obj1 ? Object.keys(obj1) : [];
  const keys2 = obj2 ? Object.keys(obj2) : [];
  return Array.from(new Set([...keys1, ...keys2]));
};
